import React, { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const buttonVariants = cva('inline-flex items-center justify-center whitespace-nowrap rounded text-sm font-semibold ring-offset-dashboard-bg transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tech-blue focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 font-mono uppercase tracking-wider', {
  variants: {
    variant: {
      default: 'bg-dashboard-surface text-dashboard-text border border-dashboard-border hover:border-tech-blue/50',
      cta: 'bg-tech-blue text-dashboard-bg hover:bg-tech-blue/90 shadow-lg hover:shadow-tech-blue/20 font-bold',
      'cta-secondary': 'bg-tech-green text-dashboard-bg hover:bg-tech-green/90 shadow-lg hover:shadow-tech-green/20',
      outline: 'border border-tech-blue/30 text-tech-blue hover:bg-tech-blue/10 hover:border-tech-blue',
      'outline-accent': 'border border-tech-green/30 text-tech-green hover:bg-tech-green/10 hover:border-tech-green',
      'outline-blue': 'border border-tech-blue/30 text-tech-blue hover:bg-tech-blue/10',
      ghost: 'hover:bg-dashboard-surface hover:text-tech-blue',
      link: 'text-tech-blue underline-offset-4 hover:underline'
    },
    size: {
      default: 'h-11 px-6 py-2.5',
      sm: 'h-9 rounded px-4 text-xs',
      lg: 'h-12 rounded px-8 text-base',
      icon: 'h-11 w-11',
      xl: 'h-14 px-10 text-base'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant,
  size,
  asChild = false,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({
    variant,
    size,
    className
  }))} ref={ref} {...props} data-id="element-397" />;
});
Button.displayName = 'Button';
export { Button, buttonVariants };